<template>
  <el-dialog
    v-if="visible"
    :visible.sync="visible"
    :lock-scroll="false"
    :before-close="closeDialog"
    :show-close="false"
    center
    width="60%"
    >
    <dialog-header
      slot="title"
      :title="$t('public.view') + ' ' + $t('geofence.name')"
      icon="icon-dialog-look"
      @close="closeDialog"
    />
    <vue-linetitle
      :title="$t('public.baseInfo')"
      :icon-config="{icon: 'approve-car-info'}"
      >
      <el-form
        size="mini"
        label-suffix="："
        :label-width="$t('geofence.style.formLabelWidth')">
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('carMonitor.electric.electricNotes.ruleName')" label-width="120px"> 
              {{formInfo.ruleName}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('carMonitor.electric.electricNotes.alarmType')">
              {{alarmTypeList.filter(r => r.value == formInfo.alarmType)[0].label}}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </vue-linetitle>
    <vue-linetitle
      :title="$t('carMonitor.electric.electricManage.wlxx')"
      :icon-config="{icon: 'approve-mileage-info'}"
      >
      <div>
        <el-form
          size="mini"
          label-suffix="："
          :label-width="$t('geofence.style.formLabelWidth')"
          >
          <el-form-item :label="$t('carMonitor.electric.electricManage.rulestype')" label-width="130px">
            <span v-if="formInfo.ruleType==0">{{$t('geofence.shape.polygon')}}</span>
            <span v-else-if="formInfo.ruleType==1">{{$t('geofence.shape.rectangle')}}</span>
            <span v-else>{{$t('geofence.shape.circle')}}</span>
          </el-form-item>
          <el-row v-if="formInfo.ruleType == 2">
            <el-col :span="12">
              <el-form-item :label="$t('geofence.centerPosition')">
                <span>{{formInfo.center.join(',')}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('geofence.radius')">
                {{shape.radius}}
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="amap">
          <vue-map
            :map-type-control="true"
            class="loading-map"
            :language="language"
            :zoom="zoom"
            :disable-default-ui="true"
            :center="center"
            :fullscreen-control="true"
            :bounds="mapBounds"
            >
            <vue-map-polygon
              ref="shapePolygon"
              v-if="shape.path.length"
              :visible="formInfo.ruleType === 0"
              :path="shape.path"
              :stroke-color="shape.strokeColor"
              :stroke-weight="shape.strokeWeight"
              :stroke-opacity="shape.strokeOpacity"
              :fill-color="shape.fillColor"
              :fill-opacity="shape.fillOpacity"
            />
            <vue-map-rectangle
              ref="shapeRectangle"
              v-if="shape.bounds.length === 2"
              :visible="formInfo.ruleType === 1"
              :bounds="shape.bounds"
              :stroke-color="shape.strokeColor"
              :stroke-weight="shape.strokeWeight"
              :stroke-opacity="shape.strokeOpacity"
              :fill-color="shape.fillColor"
              :fill-opacity="shape.fillOpacity"
            />
            <vue-map-circle
              ref="shapeCircle"
              v-if="shape.center"
              :visible="formInfo.ruleType === 2"
              :center="shape.center"
              :radius="shape.radius"
              :stroke-color="shape.strokeColor"
              :stroke-weight="shape.strokeWeight"
              :stroke-opacity="shape.strokeOpacity"
              :fill-color="shape.fillColor"
              :fill-opacity="shape.fillOpacity"
            />
          </vue-map>
        </div>
      </div>
    </vue-linetitle>
  </el-dialog>
</template>

<script>
import { getUserLanguage } from '@/utils/auth'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ([])
    }
  },
  data() {
    return {
      formInfo: {
        ruleName: '',
        alarmType: '0,1',
        ruleType: 2,
        center: []
      },
      alarmTypeList: [
        { label: this.$t('geofence.out'), value: '0' },
        { label: this.$t('geofence.in'), value: '1' },
        { label: this.$t('geofence.out') + '&' + this.$t('geofence.in'), value: '0,1' }
      ],
      language: getUserLanguage(),
      // 谷歌地图
      zoom: 15,
      center: [100.530449, 13.722944],
      mapBounds: null,
      shape: {
        // 圆形专用
        center: null,
        radius: 1000,
        // 矩形专用
        bounds: [],
        // 多边形专用
        path: [],
        strokeColor: '#0091ea',
        strokeWeight: 5,
        strokeOpacity: 1,
        fillColor: '#ffff00',
        fillOpacity: 0.5
      }
    }
  },
  watch: {
    visible: {
      handler(newVal) {
        if (newVal) {
          this.formInfo.ruleName = this.data.ruleName
          this.formInfo.ruleType = this.data.ruleType
          this.formInfo.alarmType = this.data.alarmType
          if (this.data.ruleType === 0) {
            let minLat = 90,
              maxLat = -90,
              minLng = 180,
              maxLng = -180
            this.shape.path = this.data.ruleParam.split(';').map(p => {
              const point = p.split(',').map(v => +v)
              minLat = Math.min(minLat, point[1])
              maxLat = Math.max(maxLat, point[1])
              minLng = Math.min(minLng, point[0])
              maxLng = Math.max(maxLng, point[0])
              return point
            })
            this.mapBounds = [[minLng, minLat], [maxLng, maxLat]]
          } else if (this.data.ruleType === 1) {
            const points = this.data.ruleParam.split(';').map(p => {
              return p.split(',').map(v => +v)
            })
            this.shape.bounds = [points[0], points[2]]
            this.mapBounds = this.shape.bounds
          } else {
            const params = this.data.ruleParam.split(';')
            const center = params[0].split(',').map(v => +v)
            const radius = +params[1]
            const diff = radius * 0.00001
            this.shape.center = center
            this.shape.radius = radius
            this.formInfo.center = center
            // 1米大约0.00001度
            this.mapBounds = [[center[0] - diff, center[1] - diff], [center[0] + diff, center[1] + diff]]
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    // 关闭dialog
    closeDialog() {
      this.$emit('update:visible', false)
    }
  }
}

</script>
<style lang="scss">
*{
  font-style: normal;
}
.amap{
  height: 48vh;
  width: 100%;
  margin-bottom: 10px;
  position: relative;
}
</style>